module.exports = __webpack_public_path__ + "img/icon20.5658f1fd.png";